import * as DataFeedApi from '../api/DataFeedRequest'

export const getDataFeed = (id, filters, page)=> async(dispatch)=> {
    // console.log("Inside getDataFeed")
    dispatch({type: "DATA_FEED_START"})
    try {
        // console.log("Inside DataFeedAction try block")
        const { data } = await DataFeedApi.getDataFeed(id, filters, page);
        dispatch({type: "DATA_FEED_SUCCESS", data: data.data, hasMore: data.hasMore, page, totalItems: data.totalItems});
        
    } catch (error) {
        dispatch({type: "DATA_FEED_FAIL"})
        console.log(error);
    }
}